import { useState, useCallback, useMemo } from 'react';
import { isSameDay, isAfter, isWithinInterval } from 'date-fns';
import { isRange, isStart, isEnd, shouldSelectStart, shouldSelectEnd, } from '../dateHelpers';
import { useLocale } from '../../LocaleProvider';
export function useCalendarSelection(selection = null, onSelectionChange = () => { }) {
    const { datePicker: locale } = useLocale();
    const [hovered, setHovered] = useState(null);
    const { format: formatDate } = useMemo(() => new Intl.DateTimeFormat(locale.dateLocale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }), [locale]);
    const getAriaLabel = (date) => {
        const localizedDate = formatDate(date);
        return localizedDate;
    };
    const handleMouseEnter = (date) => setHovered(date);
    const handleMouseLeave = () => setHovered(null);
    const handleSelection = useCallback((date) => {
        if (isRange(selection)) {
            if (shouldSelectStart(selection, date))
                onSelectionChange([date, null]);
            else if (shouldSelectEnd(selection))
                onSelectionChange([selection[0], date]);
        }
        else {
            onSelectionChange(date);
        }
    }, [selection, onSelectionChange]);
    const getSelectionProps = (date) => {
        var _a, _b;
        return ({
            'aria-label': getAriaLabel(date),
            onMouseEnter: () => handleMouseEnter(date),
            onMouseLeave: () => handleMouseLeave(),
            ...(isRange(selection)
                ? {
                    selected: isStart(selection, date) || isEnd(selection, date),
                    selectedRange: selection[0] !== null &&
                        (selection[1] !== null || hovered !== null) &&
                        isAfter((_a = selection[1]) !== null && _a !== void 0 ? _a : hovered, selection[0]) &&
                        isWithinInterval(date, {
                            start: selection[0],
                            end: (_b = selection[1]) !== null && _b !== void 0 ? _b : hovered,
                        }),
                }
                : {
                    selected: selection !== null && isSameDay(selection, date),
                }),
        });
    };
    return {
        handleSelection,
        getSelectionProps,
    };
}
//# sourceMappingURL=useCalendarSelection.js.map